import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';
import { CancelToken } from 'axios';

import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, TagProps } from './models'



export const addNotice = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/notices`, params);
};

export const getNoticeList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/notices`, { params });
}


export const getNotice = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/notices/${id}`);
}

export const deleteNotice = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/notices/${id}`);
}

export const pushNotice = (id: string,params:any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/notices/${id}/push`,{ ...params });
};

export const getNoticeGroup = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/notices/${id}/group`);
};

export const getNoticeSettingList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/notices/settings`, { params });
}

export const putNoticeSetting = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/notices/setting`, params);
};

export const deleteNoticeSetting = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/notices/setting/${id}`);
}

export const addMacScript = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/scripts`, params);
};

export const getMacScriptList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/mac/scripts`, { params });
}


export const getMacScript = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/scripts/${id}`);
}

export const deleteMacScript = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/scripts/${id}`);
}